/**
 * Audit event category visibility filter
 *
 * EVENT_CATEGORIES is auto-generated from api/utils/AuditEventDescriptions.ts
 * and includes every event type whose metadata has a uiCategory — including
 * categories whose backend integration isn't actually wired up. We filter
 * those out at the UI layer so the dropdown and the Events-by-Category
 * panel only show categories users can actually populate by exercising
 * the product.
 *
 * Currently hidden:
 *   - MFA: schema (UserMfaConfig), middleware (PermissionService.requireMFA),
 *     and AuditLogger.logMfaEvent all exist, but the only caller of
 *     logMfaEvent is api/services/MFAService.ts, which nothing imports —
 *     the service is unwired so MFA_* audit rows are never written. Remove
 *     this entry (and ideally MFAService.ts) once the feature is wired up.
 *
 * Add new entries here by category key from EVENT_CATEGORIES (e.g.
 * 'WORKSPACE_ACCESS') and document the reason — these are not stable;
 * we want each hidden category to come back as soon as it's real.
 */

import { EVENT_CATEGORIES } from './auditEventCategories.js';

const HIDDEN_CATEGORIES = new Set([
    'MFA',
]);

/**
 * Return EVENT_CATEGORIES entries with hidden categories filtered out,
 * preserving the auto-generated ordering. Use this everywhere the UI
 * iterates categories — never iterate EVENT_CATEGORIES directly when
 * rendering UI controls.
 */
export function getVisibleEventCategoryEntries() {
    return Object.entries(EVENT_CATEGORIES).filter(([key]) => !HIDDEN_CATEGORIES.has(key));
}

/**
 * Whether the given category key is currently exposed in the UI.
 * Useful for guards in places that already have the key in hand
 * (e.g. derived `activeCategoryKey` in the URL).
 */
export function isCategoryVisible(categoryKey) {
    return !HIDDEN_CATEGORIES.has(categoryKey);
}
